import React, { useState } from 'react';
import './HomePage.css';

import Navigation from '../../Shared/Navigation/Navigation';
import Banner from '../../PageCompos/Home/Banner/Banner';
// import Menu from '../../PageCompos/Home/Menu/Menu';
import ChefSpecial from '../../PageCompos/Home/ChefSpecial/ChefSpecial';
import Footer from '../../Shared/Footer/Footer';
import Blogs from '../../PageCompos/Home/Blogs/Blogs';
import Gallery from '../../PageCompos/Home/Gallery/Gallery';
// import Reservation from '../../PageCompos/Home/Reservation/Reservation';
import Review from '../../PageCompos/Home/Review/Review';
// import FindLocation from '../../PageCompos/Contact/FindLocation';
// import BottomBanner from '../../PageCompos/Home/BottomBanner/BottomBanner';
import Loader from '../../PageCompos/Home/Loader/Loader';
import PerfectPlace from '../../PageCompos/Home/PerfectPlace/PerfectPlace';
import HomeContact from '../../PageCompos/Home/HomeContact/HomeContact';





const HomePage = () => {
    const [load, setLoad] = useState(true)
    setTimeout(() => {
        setLoad(false);
    }, 1000)
    if (load) {
        return <Loader />
    }
    return (
        <div className=''>
            {/* <div className='home-content'> */}

            <Navigation />
            <Banner />
            <PerfectPlace />
            {/* <Menu /> */}
            <ChefSpecial />
            <Blogs />
            <Review />
            <Gallery />
            {/* <BottomBanner /> */}
            {/* <Reservation /> */}
            {/* <FindLocation /> */}
            <HomeContact />
            <Footer />
        </div>
    );
};

export default HomePage;